<template>
  <div class="business-contract" data-title="申请流程">
    <applyPartner>
      <template v-slot:top>
        <p class="title">
          申请商家
        </p>
      </template>
      <template v-slot:left>
        <dl class="contract">
          <dt>
            <img src="../../assets/images/partner-img/5.png" alt="">
          </dt>
          <dd>
            签约合同
          </dd>
        </dl>
      </template>
      <template v-slot:right>
        <dl class="prove">
          <dt>
            <img src="../../assets/images/partner-img/2.png" alt="">
          </dt>
          <dd>
            完成认证
          </dd>
        </dl>
      </template>
    </applyPartner>
    <!-- 合同 -->
    <div class="pact">
      <p class="pact-title">
        申请城市合伙人协议合同
      </p>
      <p class="pact-content">
         亲爱的用户，在您注册的康富美用户的过程中，您需要完成我
        们的注册流程并通过点击同意的形式在线签署康富美《隐私协议》
        和《隐私政策》，请务必填写阅读，充分理解协议中的条款内容后
        再点击同意，尤其是加粗字体。                                                            
      </p>
      <p class="pact-content">
        亲爱的用户，在您注册的康富美用户的过程中，您需要完成我
        们的注册流程并通过点击同意的形式在线签署康富美;                    
      </p> 

      <p class="pact-content">
         亲爱的用户，在您注册的康富美用户的过程中，您需要完成我
        们的注册流程并通过点击同意的形式在线签署康富美《隐私协议》
        和《隐私政策》，请务必填写阅读，充分理解协议中的条款内容后
        再点击同意，尤其是加粗字体。          
      </p>
      <div class="post-photo">
        <p class="title">
          注意：请上传营业执照
        </p>
        <div>

        </div>
      </div>
      <!-- 同意协议 -->
      <p class="choice-box">
        <van-checkbox v-model="checked" checked-color="#ffc201" icon-size="18px"></van-checkbox>点击同意即代表您已阅读<span>《服务协议》</span>                           
      </p>
      <!-- 同意按钮 -->
      <p class="btn">
        <img src="../../assets/images/partner-img/6.png" alt="">
        <img src="../../assets/images/partner-img/7.png" alt="" @click="next_btn">
      </p>
      <contactWay></contactWay>
    </div>
  </div>
</template>

<script>

import applyPartner from '../../components/partner/apply-partner'
import contactWay from '../../components/partner/contact-way'

import Vue from 'vue';
import { Checkbox, CheckboxGroup } from 'vant';

Vue.use(Checkbox);
Vue.use(CheckboxGroup);

export default {
  data(){
    return{
      checked: false
    }
  },
  components:{
    applyPartner,
    contactWay
  },
  methods:{
    next_btn(){
      this.$router.push('/business-progress')
    }
  }
}
</script>

<style lang="less" scoped>
  .business-contract{
    width: 7.5rem;
    display: flex;
    flex-direction: column;
    background-image: url('../../assets/images/partner-img/bag@2x.png');
    background-size: 100% 100%;
    // 协议
    .pact{
      width: 7.1rem;
      height: 10.43rem;
      background: #fff;
      margin: 0 auto;
      border-radius: .1rem;
      margin-top: .1rem;
      margin-bottom: .2rem;
      // 标题
      .pact-title{
        font-size: 0.26rem;
        font-family: PingFang SC;
        font-weight: 600;
        color: #0C0C0C;
        text-align: center;
        margin-top: .4rem;
      }
      // 内容
      .pact-content{
        width: 6.37rem;
        margin: 0 auto;
        font-size: 0.22rem;
        font-family: PingFang SC;
        font-weight: 400;
        color: #A1A1A1;
        line-height: 0.36rem;
        line-height: .4rem;
        &:nth-child(2){
          text-indent: .25rem;
          margin-top: .4rem;
        }
        &:nth-child(3){
          margin-top: .2rem;
        }
        &:last-child{
          margin-top: .2rem;
        }
      }
      // 提交照片
      .post-photo{
        .title{
          font-size: 0.22rem;
          font-family: PingFang SC;
          font-weight: 500;
          color: #FF491F;
          margin-left: .3rem;
          margin-top: .38rem;
        }
      }
      // 确认协议按钮
      .choice-box{
      display: flex;
      align-items: center;
      margin-left: .3rem;
      margin-top: .3rem;
      font-size: 0.24rem;
      font-family: PingFang SC;
      font-weight: 500;
      color: #212121;
        .van-checkbox{
          margin-right: .2rem;
        }
        span{
          color: #6B9FFF;
        }
      }
      // 同意按钮
      .btn{
        display: flex;
        align-items: center;
        margin-top: .4rem;
        img{
          &:first-child{
            width: 2.29rem;
            height: .6rem;
            margin-left: 1.04rem;
          }
          &:last-child{
            width: 2.42rem;
            height: .72rem;
            margin-left: .35rem;
          }
        }
      }
    }
  }
</style>